import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { useSelector } from 'hooks/useSelector';
import { pluralise } from 'lib/pluralise';
import React from 'react';
import {
  selectAssetFieldInstanceResultValue,
  selectAssetOrganisationId,
} from 'store/assets/selectors';
import { selectOrganisationFieldGroup } from 'store/organisations/selectors';

type Props = {
  assetId: string;
  fieldId: string;
  parentInstanceId: string | null;
  childGroupId: string;
};

export const ChildGroupAsset: React.FC<Props> = ({
  assetId,
  fieldId,
  parentInstanceId,
  childGroupId,
}) => {
  const organisationId = useSelector((state) =>
    selectAssetOrganisationId(state, assetId, childGroupId),
  );

  const group = useSelector((state) =>
    selectOrganisationFieldGroup(state, organisationId, childGroupId),
  );

  const rawChildInstanceIds = useSelector((state) =>
    selectAssetFieldInstanceResultValue(
      state,
      assetId,
      parentInstanceId,
      fieldId,
    ),
  );
  const childInstanceIds = Array.isArray(rawChildInstanceIds)
    ? rawChildInstanceIds
    : [];

  if (!group) {
    return null;
  }

  return (
    <Card label={group.name}>
      <CardRow
        label={pluralise(
          childInstanceIds,
          `1 ${group.calculatedInfo.singularName}`,
          `{x} ${group.name}`,
          `No ${group.name}`,
        )}
      />
    </Card>
  );
};
